import { SiteLayout } from "../components/SiteLayout";

export const LoadingPage = () => {
	return <SiteLayout title="Loading" mainChildren={<div>Loading</div>} />;
};

export default LoadingPage;
